export const pl = {
    // Login screen
    modal_login_capital: 'ZALOGUJ',
    placeholder_email_address: 'etykieta email',
    placeholder_password: 'etykieta hasła',
    tooltip_forgot_password: 'zapomniałeś hasła?',
    log_in: 'Zaloguj',

    // Register screen
    modal_signup_capital: 'ZAREJESTRUJ',
    placeholder_repeat_password: 'powtórz hasło',
    agree: 'Zgadzam się na ',
    terms: 'Warunki',
    modal_register_capital: 'ZAREJESTRUJ',
    full_name: 'Pełne imię',

    // Price options
    choose_price: 'WYBIERZ CENĘ',
    subscription_price: 'Subskrypcja',
    asset_price: 'kapitał',
    paywall_subscription_text:
        'Możesz usunąć swoją subskrypcję w każdej chwili.',
    modal_back: 'WSTECZ',
    next_button: 'DALEJ',

    // Payments screen
    pay: 'ZAPŁAĆ',
    pay_with: 'ZAPŁAĆ UŻYWAJĄC PAYPAL’A',
    credit_card: 'karta kredytowa',
    payment_pay: 'zapłać',
    payment_price: 'Cena',
    placeholder_voucher_code: 'kod vouchera',
    placeholder_voucher: 'dodaj voucher',
    card_number: 'numer karty',
    cardholder_name: 'imię posiadacza karty',

    // Forgot password
    forgot_pass_text: 'Wyślemy Ci link do zresetowania hasła.',
    remember_pass: ' Pamiętasz hasło?',
    reset: 'ZRESETUJ',

    // Set new password
    modal_enter_your_new_password: 'Wprowadź swoje nowe hasło.',
    modal_please_check_your_email:
        'Proszę sprawdź swój email i wprowadź token aby kontynuować.',
    placeholder_token: 'token',
    new_password: 'nowe hasło',
    repeat_new_password: 'powtórz nowe hasło',
    cancel: 'usuń',
    set: 'USTAW',

    // Change password
    update: 'aktualizacja',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Moje konto',
    member_since: 'Członek od',
    purchases: 'Moje zakupy',
    subscriptions: 'Moje subskrypcje',
    account_details: 'Detale konta',
    export_data: 'Eksportuj moje dane',
    delete_account: 'Usuń konto',

    // Purchases/Subscriptions
    purchases_link: 'Zakupy',
    subscriptions_link: 'Subskrypcje',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Historia zakupów',
    purchased: 'Zakupione',
    name: 'imię',
    active: 'aktywne',
    inactive: 'inactive',
    canceled: 'usunięte',
    type: 'Typ',
    next_transaction: 'następna transakcja',
    cancel_subscription: 'Usuń subskrypcję >',
    subscriptions_active: 'Aktywuj subskrypcję',
    expires_at: 'Wygasa',
    no_more_subscriptions: 'Nie ma żadnych więcej subskrypcji.',
    no_available_subscriptions: 'Nie ma żadnych dostępnych subskrypcji.',
    no_more_active_accesses: 'Nie ma żadnych więcej aktywnych dostępów.',
    no_more_inactive_accesses: 'Nie ma żadnych więcej nieaktywnych dostępów.',
    no_available_active_accesses:
        'Nie ma dostępnych żadnych aktywnych dostępów.',
    no_available_inactive_accesses:
        'Nie ma dostępnych żadnych nieaktywnych dostępów.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question:
        'Czy jesteś pewny, że chcesz wyeksportować dane swojego konta?',
    export: 'eksportuj',
    first_export:
        'Polecenie Eskportu Danych konta spowoduje wyeksportowanie wszystkich osobistych danych z Twojego konta. Są to poniższe dane:',
    second_export: 'Twoje informacje osobiste',
    third_export: 'Zapis historii logowania',
    fourth_export: 'Listę subskrypcji',
    fifth_export: 'Listę płatnośc',
    sixth_export: 'Historię dostępów do treści premium',
    last_export:
        'Wyeksportowane dane zostaną wysłane na Twój adres email jako załącznik.',

    // Delete account screen
    delete_question: 'Czy jesteś pewien, że chcesz usunąć konto?',
    delete: 'usuń',
    confirm: "'POTWIERDŹ",
    first_delete:
        'Polecenie Usunięcia Konta spowoduje usunięcie Twoich osobistych danych z systemu. Są to poniższe:',
    second_delete: 'Osobiste informacje podane w trakcie procesu rejestracji',
    third_delete:
        'Lokalizacja oraz informacje o urządzeniu, które zbieramy w trakcie procesu uwierzytelniania',
    fourth_delete:
        'Wszystkie inne osobiste informacje przechowywane w naszych pozostałych bazach danych',
    fifth_delete:
        'Jedyne dane osobowe,które będziemy przechowywać w systemie to te, będące częścią zapisów dotyczących transakcji I subskrypcji, jesteśmy do tego zobowiązani z powodu innych przepisów, których musimy przestrzegać.',
    sixth_delete:
        'W następstwie usunięcia danych, Twoje konto zostanie deaktywowane, co oznacza, że wszystkie Twoje aktywne subskrypcje zostaną usunięte, wszystkie obecnie aktywne dostępy kapitałów zostaną odwołane, a wszystkie aktywne sesje logowania, oprócz tej konkretnej zostaną zakończone. Nie będziesz już miał możliwości uwierzytelnienia oraz zakupu kapitału na tej platformie. Dane Twojego konta nie będą dostępne w żadnej formie dla naszych pracowników.',
    seventh_delete:
        'Procedura ta może zająć 1-2 dni, po tym czasie otrzymasz email z potwierdzeniem. Twój email zostanie usunięty z naszego system po potwierdzeniu usunięcia konta.',

    // Inputs validation
    required_field: 'Pole wymagane',
    email_field: 'proszę wprowadź poprawny adres email',
    number_field: 'Wartość musi być cyfrą',
    matchPass: 'Hasło niepoprawne',
    minpass_field: 'musi mieć co najmniej 8 znaków',
    minname_field: 'musi mieć co najmniej 2 znaki',

    // Footer
    modal_terms: 'Warunki',
    modal_privacy: 'prywatność',
    modal_more: 'WIĘCEJ',
    modal_faq: 'FAQ',
    modal_protected: 'Co to jest?',
    logout: 'Wyloguj',
    details: 'Moje detale',
    preview_protected_by_inplayer: 'Chronione przez',
    modal_support: 'Support',

    dlc_download: 'pobierz',
};



// WEBPACK FOOTER //
// ./src/i18n/polish.js